import { http, httpFile } from './http_service';

//Get all
export function all(rpId){
    return http().get(`/dashboard-rp/all/${rpId}`);
}
export function thisMonth(rpId){
    return http().get(`dashboard-rp/this-month/${rpId}`);
}

export function lastMonth(rpId){
    return http().get(`dashboard-rp/last-month/${rpId}`);
}

export function lastYear(rpId){
    return http().get(`/dashboard-rp/last-year/${rpId}`);
}

export function thisMonthLeads(rpId){
    return http().get(`dashboard-rp/this-month-leads/${rpId}`);
}

export function lastMonthLeads(rpId){
    return http().get(`dashboard-rp/last-month-leads/${rpId}`);
}

export function lastYearLeads(rpId){
    return http().get(`/dashboard-rp/last-year-leads/${rpId}`);
}



